import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import {
    Badge,
    Button,
    Card,
    CardBody,
    DropdownMenu,
    DropdownToggle,
    Input,
    DropdownItem,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    UncontrolledDropdown,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import {
    AxiosAPI,
    getGroupID,
    getUserID,
} from '../../../../../../helpers/AxiosAPI';
import { connect } from 'react-redux';
import { gAPI_GetUsersAuditLogs_list } from '../../../../../../constants/APIs';
import moment from 'moment';
import Pagination from '../../../../../../containers/pages/Pagination';
import JSON5 from 'json5';

function generateRandomColor() {
    var arr = [
        'primary',
        'secondary',
        'info',
        'success',
        'warning',
        'danger',
        'light',
        'dark',
    ];
    return arr[Math.floor(Math.random() * arr.length)];
}

function AuditLogsList({ logType, toggle, visible }) {
    const [logList, setLogList] = useState([]);
    const [pageSizes, setpageSizes] = useState([25, 50, 75, 100]);
    const [currentPage, setcurrentPage] = useState(1);
    const [SelectedPageSize, setSelectedPageSize] = useState(25);
    const startIndex = (currentPage - 1) * SelectedPageSize;
    const endIndex = currentPage * SelectedPageSize;
    const [TotalItems, setTotalItems] = useState(0);
    const [TotalPages, setTotalPages] = useState(1);

    const changePageSize = (size) => {
        setSelectedPageSize(size);
        setcurrentPage(1);
    };

    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_GetUsersAuditLogs_list}?gid=${getGroupID()}&pid=-1&type=${logType}&pageNumber=${currentPage}&pageSize=${SelectedPageSize}`,
        }).then((res) => {
            setTotalItems(res.data.totalItems);
            setTotalPages(res.data.totalPages);
            setLogList(res.data.logs);
        });
    }, [logType, currentPage, SelectedPageSize]);

    const onChangePage = (page) => {
        setcurrentPage(page);
    };
    const contentDisplay = (content) => {

        const fieldMap = {
            email: 'Email',
            firstName: 'First Name',
            lastName: 'Last Name',
            roles: 'Roles',
            status: 'Status',
            properties: 'Properties',
            phoneNumber: 'Phone Number',
            reason: 'Reason',
        };
        const formatValue = (key, value) => {
            // console.log('val', typeof value);
            if (key === 'properties') {
                if (Array.isArray(value)) {
                    return value.join(', ');
                } else if (typeof value === 'string') {
                    return value.split(',').join(', ');
                } else {
                    return String(value);
                }
            }
            return value;
        };

        return (
            <div className="mb-2 text-left">
                {Object.keys(fieldMap).map((key) => {
                    const value = content[key];
                    if (value !== undefined && value !== null && value !== '') {
                        return (
                            <div className="mb-2" key={key}>
                                <strong>{fieldMap[key]}:</strong>{' '}
                                {formatValue(key, value)}
                            </div>
                        );
                    }
                    return null;
                })}
            </div>

        );
    }


    return (
        <Fragment>
            <Modal size="lg" isOpen={visible} toggle={toggle}>
                <ModalHeader toggle={toggle}></ModalHeader>
                <ModalBody>
                    <Row className="">
                        <Colxx xxs="12" className="mb-3">
                            <div className="float-md-right">
                                <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
                                <UncontrolledDropdown className="d-inline-block">
                                    <DropdownToggle caret color="outline-dark" size="xs">
                                        {SelectedPageSize}
                                    </DropdownToggle>
                                    <DropdownMenu right>
                                        {pageSizes.map((size, index) => {
                                            return (
                                                <DropdownItem
                                                    key={index}
                                                    onClick={() => changePageSize(size)}
                                                >
                                                    {size}
                                                </DropdownItem>
                                            );
                                        })}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        </Colxx>
                        <Colxx xxs="12">
                            {logList !== undefined &&
                                logList.length > 0 &&
                                logList.map((m, index) => {
                                    let contentToDisplay = {};
                                    if (m.content !== undefined && m.content !== null && m.content !== "") {
                                        try {
                                            contentToDisplay = JSON5.parse(m.content);
                                            console.log('logscontent', contentToDisplay);
                                        } catch (e) {
                                            console.error('Failed to parse content:', m);
                                        }
                                    }
                                    return (
                                        <Row className="mb-3" key={`Item_${index}`}>
                                            <Colxx xxs="12">
                                                <Card
                                                    className="d-flex text-center mb-3"
                                                    style={{ borderRadius: '20px' }}
                                                >
                                                    <CardBody>
                                                        <Row className="mb-2 text-left">
                                                            <Colxx xxs="3" className="mb-2">
                                                                {m.userEmail}
                                                            </Colxx>
                                                            <Colxx xxs="5" className="mb-2">
                                                                {contentDisplay(contentToDisplay)}
                                                            </Colxx>
                                                            <Colxx xxs="2" className="mb-2">
                                                                {m.action}
                                                            </Colxx>
                                                            <Colxx xxs="2" className="mb-2">
                                                                {moment(m.createdUtc).format('MMM, DD YYYY hh:mm a')}
                                                            </Colxx>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Colxx>
                                        </Row>
                                    )
                                }
                                )}
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId,
        locale,
    };
};

export default injectIntl(connect(mapStateToProps, {})(AuditLogsList));
